import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import Nav from '../components-public/Nav'
import Footer from '../components-public/Footer'
import { usePublicPost } from '../hooks/usePosts'
import { estimateReadTime } from '../lib/helpers'

export default function BlogPostPage() {
  const { slug } = useParams()
  const { post, loading } = usePublicPost(slug)

  const seoTitle = post?.seo_title || post?.title || 'Artigo | Orken'
  const seoDesc = post?.seo_description || post?.excerpt || 'Leia o artigo no blog da Orken Tecnologia.'
  const seoImage = post?.seo_image_url || post?.cover_image_url || ''

  return (
    <>
      <Helmet>
        <title>{seoTitle} | Blog Orken</title>
        <meta name="description" content={seoDesc} />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDesc} />
        {seoImage && <meta property="og:image" content={seoImage} />}
        <link rel="canonical" href={`https://orkentecnologia.com.br/blog/${slug}`} />
      </Helmet>
      <Nav />
      <main style={{ paddingTop: 104 }}>
        {loading && (
          <div className="section">
            <div className="section-inner" style={{ maxWidth: 800 }}>
              <div style={{ height: 40, width: '70%', background: 'var(--bg-2)', borderRadius: 8, marginBottom: 24 }} />
              <div style={{ height: 16, width: '30%', background: 'var(--bg-2)', borderRadius: 4, marginBottom: 40 }} />
              <div style={{ height: 16, width: '100%', background: 'var(--bg-2)', borderRadius: 4, marginBottom: 8 }} />
              <div style={{ height: 16, width: '90%', background: 'var(--bg-2)', borderRadius: 4, marginBottom: 8 }} />
              <div style={{ height: 16, width: '95%', background: 'var(--bg-2)', borderRadius: 4 }} />
            </div>
          </div>
        )}
        {post && (
          <article className="section">
            <div className="section-inner" style={{ maxWidth: 800 }}>
              {post.cover_image_url && (
                <img src={post.cover_image_url} alt={post.title} style={{ width: '100%', height: 320, objectFit: 'cover', borderRadius: 16, marginBottom: 32 }} />
              )}
              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 12 }}>
                {post.published_at ? new Date(post.published_at).toLocaleDateString('pt-BR') : new Date(post.created_at).toLocaleDateString('pt-BR')}
                {' · '}{estimateReadTime(post.content)} min de leitura
              </div>
              <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 36, fontWeight: 800, color: 'var(--text)', marginBottom: 24 }}>{post.title}</h1>
              <div style={{ fontSize: 16, color: 'var(--text-dim)', lineHeight: 1.75 }} dangerouslySetInnerHTML={{ __html: post.content }} />
              {(post.tags || []).length > 0 && (
                <div className="case-tags" style={{ marginTop: 40 }}>
                  {post.tags.map(t => <span className="case-tag" key={t}>{t}</span>)}
                </div>
              )}
            </div>
          </article>
        )}
        {!loading && !post && (
          <div className="section">
            <div className="section-inner" style={{ maxWidth: 800, textAlign: 'center' }}>
              <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 800, color: 'var(--text)', marginBottom: 16 }}>Artigo não encontrado</h1>
              <p style={{ color: 'var(--text-dim)' }}>O artigo que você buscou não existe ou ainda não foi publicado.</p>
            </div>
          </div>
        )}
      </main>
      <Footer />
    </>
  )
}
